import React, { useState } from 'react';
import axios from 'axios';
import '../styles/admin.css';

const PostProject = () => {
    const [title, setTitle] = useState('');
    const [location, setLocation] = useState('');
    const [description, setDescription] = useState('');
    const [image, setImage] = useState(null);

    const API = process.env.REACT_APP_API_URL;


    const handleImageChange = (e) => {
        setImage(e.target.files[0]);
        console.log(e.target.files[0]);
    };


    const createProject = async (event) => {
        event.preventDefault();

        if (!image) {
            console.error('No image file selected!');
            return;
        }

        const formData = new FormData();
        formData.append('title', title);
        formData.append('description', description);
        formData.append('location', location);
        formData.append('file', image);

        try {
            const token = localStorage.getItem("authToken")
            const response = await axios.post(`${API}/api/projects`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }

            });

            alert('project posted successfully')

            console.log('Project created:', response.data);

            setTitle('');
            setLocation('');
            setDescription('');
            setImage(null);
        } catch (error) {
            console.error('Error creating project:', error.response?.data || error.message);
        }
    };


    return (
        <div id="post-project-bod">
            <form className="admin-form" id="create-post-form">
                <input
                    type="text"
                    className="admin-form-input"
                    placeholder="Title"
                    name="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                <input
                    type="text"
                    className="admin-form-input"
                    placeholder="Location"
                    name="location"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                />
                <textarea
                    className="admin-form-textarea"
                    placeholder="Description"
                    name="description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />

                <label htmlFor="fileUpload" className="custom-label">
                    Choose Image
                </label>
                <input
                    type="file"
                    id="fileUpload"
                    onChange={handleImageChange}
                    name="file"
                    className="hidden-input"
                />
                <button
                    typeof='submit'
                    onClick={createProject}
                    className="admin-form-btn"
                >
                    Post
                </button>
            </form>
        </div>
    );
};

export default PostProject;
